var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_65192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.6715 38.0664C93.9063 39.6484 92.793 41.1717 91.2108 41.4062H90.8006C89.3358 41.4062 88.1051 40.3516 87.8709 38.8867C85.234 20.3123 68.8086 5.85938 49.9998 5.85938C31.191 5.85938 14.7656 20.3123 12.1287 38.8867C11.8946 40.4686 10.4297 41.6404 8.78889 41.4062C7.20666 41.1717 6.09338 39.6484 6.32815 38.0664C9.37463 16.5625 28.2613 0 49.9998 0C71.7383 0 90.625 16.5625 93.6715 38.0664Z",
    fill: "#57555C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6717 38.0664C93.9064 39.6484 92.7932 41.1717 91.2109 41.4062H90.8008C89.3359 41.4062 88.1053 40.3516 87.8711 38.8867C85.2342 20.3123 68.8088 5.85938 50 5.85938V0C71.7385 0 90.6252 16.5625 93.6717 38.0664Z",
    fill: "#3C3A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 23.8281C35.4689 23.8281 23.4375 35.6643 23.4375 50.1953C23.4375 54.6484 24.6094 59.043 26.8361 63.0273L23.6135 72.6955C23.2615 73.7502 23.4961 74.9217 24.3166 75.6834C25.0783 76.5037 26.25 76.7385 27.3045 76.3865L37.168 73.1639C41.1523 75.3906 45.5469 76.5625 50 76.5625C64.5311 76.5625 76.5625 64.7264 76.5625 50.1953C76.5625 35.6643 64.5311 23.8281 50 23.8281Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 50.1953C76.5625 64.7264 64.5311 76.5625 50 76.5625V23.8281C64.5311 23.8281 76.5625 35.6643 76.5625 50.1953Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 38.4766C52.9297 40.1174 51.6408 41.4062 50 41.4062C48.3592 41.4062 47.0703 40.1174 47.0703 38.4766C47.0703 36.8357 48.3592 35.5469 50 35.5469C51.6408 35.5469 52.9297 36.8357 52.9297 38.4766ZM52.9297 50.1953V61.9141C52.9297 63.5549 51.6408 64.8438 50 64.8438C48.3592 64.8438 47.0703 63.5549 47.0703 61.9141V50.1953C47.0703 48.5545 48.3592 47.2656 50 47.2656C51.6408 47.2656 52.9297 48.5545 52.9297 50.1953Z",
    fill: "#B7E0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 41.4062V35.5469C51.6408 35.5469 52.9297 36.8357 52.9297 38.4766C52.9297 40.1174 51.6408 41.4062 50 41.4062ZM52.9297 50.1953V61.9141C52.9297 63.5549 51.6408 64.8438 50 64.8438V47.2656C51.6408 47.2656 52.9297 48.5545 52.9297 50.1953Z",
    fill: "#A4D9F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6484 76.5625H8.78906C3.94258 76.5625 0 72.6199 0 67.7734V44.3359C0 39.4895 3.94258 35.5469 8.78906 35.5469H14.6484C16.2678 35.5469 17.5781 36.8572 17.5781 38.4766V73.6328C17.5781 75.2521 16.2678 76.5625 14.6484 76.5625Z",
    fill: "#FD3018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6328 94.1406H55.8594C54.24 94.1406 52.9297 92.8303 52.9297 91.2109C52.9297 89.5916 54.24 88.2812 55.8594 88.2812H73.6328C81.7096 88.2812 88.2812 81.7096 88.2812 73.6328C88.2812 72.0135 89.5916 70.7031 91.2109 70.7031C92.8303 70.7031 94.1406 72.0135 94.1406 73.6328C94.1406 84.9396 84.9396 94.1406 73.6328 94.1406Z",
    fill: "#3C3A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2109 76.5625H85.3516C83.7322 76.5625 82.4219 75.2521 82.4219 73.6328V38.4766C82.4219 36.8572 83.7322 35.5469 85.3516 35.5469H91.2109C96.0574 35.5469 100 39.4895 100 44.3359V67.7734C100 72.6199 96.0574 76.5625 91.2109 76.5625Z",
    fill: "#E61E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 82.4219C45.1365 82.4219 41.2109 86.3475 41.2109 91.2109C41.2109 96.074 45.1365 100 50 100C54.8635 100 58.7891 96.074 58.7891 91.2109C58.7891 86.3475 54.8635 82.4219 50 82.4219Z",
    fill: "#FD3018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7891 91.2109C58.7891 96.074 54.8635 100 50 100V82.4219C54.8635 82.4219 58.7891 86.3475 58.7891 91.2109Z",
    fill: "#E61E14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_65192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/Headphone.ee0cbd5b8032553b806cf470e9eaf6a1.svg";
export { ForwardRef as ReactComponent };